/* global axios */
import ApiClient from '../ApiClient';

class CaptainDocument extends ApiClient {
  constructor() {
    super('captain/documents', { accountScoped: true });
  }

  get({ page = 1, searchKey, assistantId, teamId, filter, source, sort } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        search_key: searchKey,
        assistant_id: assistantId,
        team_id: teamId,
        filter,
        source,
        sort,
      },
    });
  }

  reprocess(documentId) {
    return axios.post(`${this.url}/${documentId}/reprocess`);
  }

  regenerateFaqs(documentId) {
    return axios.post(`${this.url}/${documentId}/regenerate_faqs`);
  }

  sync(id) {
    return axios.post(`${this.url}/${id}/sync`);
  }
}

export default new CaptainDocument();
